import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { ModalContextProvider } from '@components/Modal/ModalContextProvider';

const useStyles = makeStyles(() => ({
	manageCaseMenu: {
		display: 'flex',
		justifyContent: 'center',
	},
}));

export const SurgeonEventManageCaseMenuContainer: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ children }) => {
	const classes = useStyles();
	return (
		<Box className={classes.manageCaseMenu}>
			<ModalContextProvider>
				{children}
			</ModalContextProvider>
		</Box>
	);
};
